const styles = () => ({
  dialogTitle: {
    background: '#EEF0F2',
  },
  dialogContent: {
    padding: 0,
  }
});

export default styles;